// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/GothamRounded-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/GothamRounded-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warningMsg {
  color: black;
  font-family: "GothamRounded-Book";
  font-weight: 400 !important;
  padding-left: 5%;
  background-color: #e3e1d8;
  padding-left: 20px;
}

.WelcomeImg {
  height: 45%;
  width: 75%;
  margin-left: 4%;
  margin-top: 10%;
}

.DowntimeImg {
  height: 40%;
  width: 50%;
  margin-left: 28%;
}

.warningMsgDiv {
  width: 90%;
  font-size: 20px;
}

.btnAlignmentUserDetails {
  display: flex;
  justify-content: flex-end;
  /* margin-top: 15%; */
}
.btnAlignment {
  display: flex;
  justify-content: flex-end;
  /* margin-top: -4%; */
}

.fileryWizard {
  position: relative;
  min-height: 100vh;
  background-color: #009de0;
  box-shadow: 9px 21px 48px 11px rgba(0, 0, 0, 0.44);
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

.row {
  min-height: 290px !important;
  max-height: 290px !important;
}

.container {
  justify-content: space-between;
  flex-direction: column;
  height: 100vh;
  display: flex;
}

.container .btn-holder {
  justify-content: flex-end;
  display: flex;
}

.logo {
  width: 7%;
  padding-bottom: 7px;
}

.sectionDivider {
  width: 100%;
  background-color: #337ab7 !important;
}

.color {
  background-color: #337ab7 !important;
  height: 60px;
}
.msgBox {
  border: 3px solid #fff;
  border-radius: 15px;
  padding-bottom: 3%;
  padding-top: 4%;
  text-align: center;
  font-family: "GothamRounded-Book";
  font-style: normal;
  padding-left: 4%;
}
.main {
  width: 50%;
  margin: 50px auto;
}

.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}

.metaDataFieldtxt {
  color: #fff;
  font-weight: bold;
  display: block;
  padding-left: 6%;
}

.userDetailsFieldtxt {
  color: #fff;
  font-weight: bold;
  display: block;
}
.metaDataFieldValue {
  color: black;
  width: 93%;
  min-height: 35px;
  max-height: 35px;
  border: 0px;
  background-color: #e3e1d8;
  padding-left: 3%;
}

.metaDataFieldNoValue {
  width: 93%;
  min-height: 35px;
  max-height: 35px;
  border: 0px;
  background-color: #e3e1d8;
  padding-left: 3%;
  color: #c10505;
  font-style: italic;
}
.UserDetailsFieldtxt {
  color: #fff;
  font-weight: bold;
  display: block;
  padding-bottom: 2%;
}
.UserDetailsFiledValue {
  color: black;
  width: 90%;
  min-height: 35px;
  max-height: 35px;
  border: 0px;
}

.iconOtherStyle {
  font-size: 125%;
}

.srchIconStyle {
  font-size: 20px;
}

.srchTxtStyle {
  width: 90%;
  display: block;
  width: 90%;
  height: 40px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.btnDesign {
  position: flex !important;
  margin-right: 10%;
  order: solid 0px;
  border-color: #f4f4f4;
  color: #333;
  border-radius: 0;
  text-transform: none;
  font-weight: 400;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 6px 12px;
  line-height: 1.42857;
  border-radius: 4px;
  margin-right: 0%;
  right: 0;
  margin-top: 0%;
  font-family: "GothamRounded-Book";
  font-style: normal;
  border-radius: 0;
  /* width: 4%; */
  font-size: 14px !important;
}

.modal-window {
  background-color: #009de0 !important;
  color: white !important;
  position: absolute;
  margin: auto;
  width: 50em;
  height: 100vh;
  right: 0px;
  overflow-y: scroll;
  min-width: 0% !important;
}

.divContentLeft {
  background-color: #f4f3ef !important;
  position: absolute;
  margin: auto;
  width: 50%;
  height: 100vh;
  left: 0px;
  overflow-y: auto;
}

.divContentRight {
  background-color: #009de0 !important;
  color: white !important;
  position: absolute;
  margin: auto;
  width: 50%;
  height: 100vh;
  right: 0px;
  overflow-y: auto;
  min-width: 0% !important;
}

.btnDesign:hover {
  color: #020f14 !important;
}

.divStyle {
  padding-bottom: 5%;
}

.hearStyle {
  background-color: rgba(0, 156, 223, 1);
  color: white;
  padding-top: 15px;
  padding-right: 15px;
  padding-bottom: 12px;
  padding-left: 15px;
}
.logoRamboll {
  float: left;
  margin-top: 1px;
  cursor: pointer;
  margin-left: 20%;
  padding: 10px;
  width: 100%;
  height: 88%;
  margin-top: 10%;
}

.logoRamboll1{
  float: left;
  margin-top: 100px;
  cursor: pointer;
  margin-left: 5%;
  width: 20%;
  height: 4%;

}

.projTitle {
  font-family: "GothamRounded-Medium";
  color: white;
  font-size: 25px;
  padding-left: 5%;
  padding-bottom: 5%;
}

.downtimeTxt {
  font-family: "GothamRounded-Medium";
  color: white;
  font-size: 25px;
  padding-top: 8%;
  padding-left: 33%;
}

.downtimeMsg {
  font-family: "GothamRounded-Medium";
  color: white;
  font-size: 25px;
  padding-left: 5%;
}

.titleHeader {
  float: left;
  margin-left: 15px;
  margin-top: 6px;
  color: white;
  font-family: "GothamRounded-Book";
  cursor: pointer;
  margin-right: 20px;
  font-size: 9px;
}

.navbarButton {
  color: #ffffff !important;
  padding: 0.5rem 1rem !important;
}
.navHeader {
  padding-top: 10px;
  padding-right: 15px;
  padding-bottom: 12px;
  padding-left: 15px;
  background-color: rgba(0, 156, 223, 1);
  height: 75px;
  line-height: 48px;
}

.headerTitle {
  float: left;
  margin-left: 4%;
  margin-top: 5px;
  color: white;
  font-family: "GothamRounded-medium";
  cursor: pointer;
  margin-right: 30px;
  font-size: 40px;
}

.app--footer {
  background-color: #0099cc;
  color: #ffffff;
  padding: 15px;
  position: absolute;
  width: 100%;
  height: 35px;
  bottom: 0;
}
.userDescriptions {
  width: 30em;
  padding-top: 8%;
  font-family: 'GothamRounded-Book';
}

.userValues {
  width: 29em;
}

.alignUserInfo {
  display: flex;
  height: 18vh;
}

.pjTempstyle {
  width: 25em;
}

.pjMemStyle {
  width: 25em;
}

.pjAssStyle {
  width: 25em;
}
.vGrpstyle {
  width: 25em;
}

body {
  font-family: "GothamRounded-Book";
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

.app--shell {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 7rem 1fr auto;
  height: 100%;
}

.app--header,
.app--footer {
  background: rgba(0, 156, 223, 1);
  color: rgb(255, 255, 255);
  padding: 1rem;
}

.app--header {
  background: rgb(225, 225, 225);
  border-bottom: 1px solid rgb(127, 127, 127);
  padding: 0.6rem;
}

.app--header h1 {
  margin: 0 0 1rem 0;
  padding: 0;
}

.app--nav {
  display: flex;
  column-gap: 1rem;
}

.app--screen {
  padding: 2rem 1rem;
}

.app--screen h2 {
  margin: 0 0 1rem 0;
  padding: 0;
}

.app--footer {
  background: rgba(0, 156, 223, 1);
  color: rgb(255, 255, 255);
  padding: 1rem;
}

.copyright {
  margin: 0;
  padding: 0;
  text-align: center;
}

.btn-primary {
  color: black !important;
  width: 90% !important;
  text-align: left !important;
  background-color: white !important;
  border-radius: 0% !important;
}
.people-picker {
  min-height: 50%;
  max-height: 50%;
  overflow: scroll;
}

.basic-multi-select {
  color: #000000;
  border-radius: 0px;
  border-color: white;
  font-weight: 400;
  display: block;
  border-radius: 0px;
  width: 100%;
  font-family: "GothamRounded-Book";
}
mgt-people-picker {
  padding: 6px 0px 0px !important;
  --input-border: white !important;
}

.css-13cymwt-control {
  border-radius: 0px !important;
}

.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root.mui-focused {
  color: rgb(3, 20, 75) !important;
}

.flyout {
  min-height: 80px !important;
  max-height: 80px !important;
}
.hintMsg {
  background-color: rgb(255, 141, 82);
  width: 100% !important;
  height: 3%;
  text-align: center;
}

.css-13cymwt-control {
  overflow: auto;
  max-height: 13%;
}

.people-picker .flyout .search-box__input {
  font-family: "GothamRounded-Book";
  font-size: 1rem;
  padding-left: 2%;
}

.msgBoxStyle {
  padding-left: 6.5%;
  width: 97%;
}

/*Hide search Number Arrows */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.css-1ahcgob-MuiButtonBase-root-MuiRadio-root.Mui-checked {
  color: white !important;
}

@font-face {
  font-family: GothamRounded-Book;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.GothamRounded-Book {
  font-family: GothamRounded-Book;
}

@font-face {
  font-family: GothamRounded-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.GothamRounded-Medium {
  font-family: GothamRounded-Medium;
}

/*----*/
/* Add this CSS to your styles.css file or create a new CSS file for this component */
.metadata-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* min-height: 100vh; */
  padding: 20px;
}

.button-container {
  position: absolute;
  bottom: auto;
  left: 0;
  right: 5;
  padding: 20px;
  display: block;
  justify-content: space-between;
}

@media (max-width: 768px) {
  /* Add media query for smaller screens */
  .button-container {
    flex-direction: column;
    align-items: center;
  }
}

.homePageDescription {
  font-family: "GothamRounded-Medium";
  font-size: 20px;
  padding-left: 5%;
}
.homePageTitle {
  font-family: "GothamRounded-Medium";
  font-size: 30px;
  padding: 5%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wEACsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,UAAU;EACV,UAAU;;AAEZ;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,4CAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,4CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA,OAAO;AACP,qFAAqF;AACrF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,WAAW;EACX,WAAW;AACb","sourcesContent":[".warningMsg {\n  color: black;\n  font-family: \"GothamRounded-Book\";\n  font-weight: 400 !important;\n  padding-left: 5%;\n  background-color: #e3e1d8;\n  padding-left: 20px;\n}\n\n.WelcomeImg {\n  height: 45%;\n  width: 75%;\n  margin-left: 4%;\n  margin-top: 10%;\n}\n\n.DowntimeImg {\n  height: 40%;\n  width: 50%;\n  margin-left: 28%;\n}\n\n.warningMsgDiv {\n  width: 90%;\n  font-size: 20px;\n}\n\n.btnAlignmentUserDetails {\n  display: flex;\n  justify-content: flex-end;\n  /* margin-top: 15%; */\n}\n.btnAlignment {\n  display: flex;\n  justify-content: flex-end;\n  /* margin-top: -4%; */\n}\n\n.fileryWizard {\n  position: relative;\n  min-height: 100vh;\n  background-color: #009de0;\n  box-shadow: 9px 21px 48px 11px rgba(0, 0, 0, 0.44);\n}\n\n.row:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.row {\n  min-height: 290px !important;\n  max-height: 290px !important;\n}\n\n.container {\n  justify-content: space-between;\n  flex-direction: column;\n  height: 100vh;\n  display: flex;\n}\n\n.container .btn-holder {\n  justify-content: flex-end;\n  display: flex;\n}\n\n.logo {\n  width: 7%;\n  padding-bottom: 7px;\n}\n\n.sectionDivider {\n  width: 100%;\n  background-color: #337ab7 !important;\n}\n\n.color {\n  background-color: #337ab7 !important;\n  height: 60px;\n}\n.msgBox {\n  border: 3px solid #fff;\n  border-radius: 15px;\n  padding-bottom: 3%;\n  padding-top: 4%;\n  text-align: center;\n  font-family: \"GothamRounded-Book\";\n  font-style: normal;\n  padding-left: 4%;\n}\n.main {\n  width: 50%;\n  margin: 50px auto;\n}\n\n.has-search .form-control {\n  padding-left: 2.375rem;\n}\n\n.has-search .form-control-feedback {\n  position: absolute;\n  z-index: 2;\n  display: block;\n  width: 2.375rem;\n  height: 2.375rem;\n  line-height: 2.375rem;\n  text-align: center;\n  pointer-events: none;\n  color: #aaa;\n}\n\n.metaDataFieldtxt {\n  color: #fff;\n  font-weight: bold;\n  display: block;\n  padding-left: 6%;\n}\n\n.userDetailsFieldtxt {\n  color: #fff;\n  font-weight: bold;\n  display: block;\n}\n.metaDataFieldValue {\n  color: black;\n  width: 93%;\n  min-height: 35px;\n  max-height: 35px;\n  border: 0px;\n  background-color: #e3e1d8;\n  padding-left: 3%;\n}\n\n.metaDataFieldNoValue {\n  width: 93%;\n  min-height: 35px;\n  max-height: 35px;\n  border: 0px;\n  background-color: #e3e1d8;\n  padding-left: 3%;\n  color: #c10505;\n  font-style: italic;\n}\n.UserDetailsFieldtxt {\n  color: #fff;\n  font-weight: bold;\n  display: block;\n  padding-bottom: 2%;\n}\n.UserDetailsFiledValue {\n  color: black;\n  width: 90%;\n  min-height: 35px;\n  max-height: 35px;\n  border: 0px;\n}\n\n.iconOtherStyle {\n  font-size: 125%;\n}\n\n.srchIconStyle {\n  font-size: 20px;\n}\n\n.srchTxtStyle {\n  width: 90%;\n  display: block;\n  width: 90%;\n  height: 40px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,\n    -webkit-box-shadow ease-in-out 0.15s;\n}\n\n.btnDesign {\n  position: flex !important;\n  margin-right: 10%;\n  order: solid 0px;\n  border-color: #f4f4f4;\n  color: #333;\n  border-radius: 0;\n  text-transform: none;\n  font-weight: 400;\n  cursor: pointer;\n  border: 1px solid transparent;\n  padding: 6px 12px;\n  line-height: 1.42857;\n  border-radius: 4px;\n  margin-right: 0%;\n  right: 0;\n  margin-top: 0%;\n  font-family: \"GothamRounded-Book\";\n  font-style: normal;\n  border-radius: 0;\n  /* width: 4%; */\n  font-size: 14px !important;\n}\n\n.modal-window {\n  background-color: #009de0 !important;\n  color: white !important;\n  position: absolute;\n  margin: auto;\n  width: 50em;\n  height: 100vh;\n  right: 0px;\n  overflow-y: scroll;\n  min-width: 0% !important;\n}\n\n.divContentLeft {\n  background-color: #f4f3ef !important;\n  position: absolute;\n  margin: auto;\n  width: 50%;\n  height: 100vh;\n  left: 0px;\n  overflow-y: auto;\n}\n\n.divContentRight {\n  background-color: #009de0 !important;\n  color: white !important;\n  position: absolute;\n  margin: auto;\n  width: 50%;\n  height: 100vh;\n  right: 0px;\n  overflow-y: auto;\n  min-width: 0% !important;\n}\n\n.btnDesign:hover {\n  color: #020f14 !important;\n}\n\n.divStyle {\n  padding-bottom: 5%;\n}\n\n.hearStyle {\n  background-color: rgba(0, 156, 223, 1);\n  color: white;\n  padding-top: 15px;\n  padding-right: 15px;\n  padding-bottom: 12px;\n  padding-left: 15px;\n}\n.logoRamboll {\n  float: left;\n  margin-top: 1px;\n  cursor: pointer;\n  margin-left: 20%;\n  padding: 10px;\n  width: 100%;\n  height: 88%;\n  margin-top: 10%;\n}\n\n.logoRamboll1{\n  float: left;\n  margin-top: 100px;\n  cursor: pointer;\n  margin-left: 5%;\n  width: 20%;\n  height: 4%;\n\n}\n\n.projTitle {\n  font-family: \"GothamRounded-Medium\";\n  color: white;\n  font-size: 25px;\n  padding-left: 5%;\n  padding-bottom: 5%;\n}\n\n.downtimeTxt {\n  font-family: \"GothamRounded-Medium\";\n  color: white;\n  font-size: 25px;\n  padding-top: 8%;\n  padding-left: 33%;\n}\n\n.downtimeMsg {\n  font-family: \"GothamRounded-Medium\";\n  color: white;\n  font-size: 25px;\n  padding-left: 5%;\n}\n\n.titleHeader {\n  float: left;\n  margin-left: 15px;\n  margin-top: 6px;\n  color: white;\n  font-family: \"GothamRounded-Book\";\n  cursor: pointer;\n  margin-right: 20px;\n  font-size: 9px;\n}\n\n.navbarButton {\n  color: #ffffff !important;\n  padding: 0.5rem 1rem !important;\n}\n.navHeader {\n  padding-top: 10px;\n  padding-right: 15px;\n  padding-bottom: 12px;\n  padding-left: 15px;\n  background-color: rgba(0, 156, 223, 1);\n  height: 75px;\n  line-height: 48px;\n}\n\n.headerTitle {\n  float: left;\n  margin-left: 4%;\n  margin-top: 5px;\n  color: white;\n  font-family: \"GothamRounded-medium\";\n  cursor: pointer;\n  margin-right: 30px;\n  font-size: 40px;\n}\n\n.app--footer {\n  background-color: #0099cc;\n  color: #ffffff;\n  padding: 15px;\n  position: absolute;\n  width: 100%;\n  height: 35px;\n  bottom: 0;\n}\n.userDescriptions {\n  width: 30em;\n  padding-top: 8%;\n  font-family: 'GothamRounded-Book';\n}\n\n.userValues {\n  width: 29em;\n}\n\n.alignUserInfo {\n  display: flex;\n  height: 18vh;\n}\n\n.pjTempstyle {\n  width: 25em;\n}\n\n.pjMemStyle {\n  width: 25em;\n}\n\n.pjAssStyle {\n  width: 25em;\n}\n.vGrpstyle {\n  width: 25em;\n}\n\nbody {\n  font-family: \"GothamRounded-Book\";\n  margin: 0;\n  padding: 0;\n  min-height: 100vh;\n}\n\n.app--shell {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 7rem 1fr auto;\n  height: 100%;\n}\n\n.app--header,\n.app--footer {\n  background: rgba(0, 156, 223, 1);\n  color: rgb(255, 255, 255);\n  padding: 1rem;\n}\n\n.app--header {\n  background: rgb(225, 225, 225);\n  border-bottom: 1px solid rgb(127, 127, 127);\n  padding: 0.6rem;\n}\n\n.app--header h1 {\n  margin: 0 0 1rem 0;\n  padding: 0;\n}\n\n.app--nav {\n  display: flex;\n  column-gap: 1rem;\n}\n\n.app--screen {\n  padding: 2rem 1rem;\n}\n\n.app--screen h2 {\n  margin: 0 0 1rem 0;\n  padding: 0;\n}\n\n.app--footer {\n  background: rgba(0, 156, 223, 1);\n  color: rgb(255, 255, 255);\n  padding: 1rem;\n}\n\n.copyright {\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n\n.btn-primary {\n  color: black !important;\n  width: 90% !important;\n  text-align: left !important;\n  background-color: white !important;\n  border-radius: 0% !important;\n}\n.people-picker {\n  min-height: 50%;\n  max-height: 50%;\n  overflow: scroll;\n}\n\n.basic-multi-select {\n  color: #000000;\n  border-radius: 0px;\n  border-color: white;\n  font-weight: 400;\n  display: block;\n  border-radius: 0px;\n  width: 100%;\n  font-family: \"GothamRounded-Book\";\n}\nmgt-people-picker {\n  padding: 6px 0px 0px !important;\n  --input-border: white !important;\n}\n\n.css-13cymwt-control {\n  border-radius: 0px !important;\n}\n\n.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root.mui-focused {\n  color: rgb(3, 20, 75) !important;\n}\n\n.flyout {\n  min-height: 80px !important;\n  max-height: 80px !important;\n}\n.hintMsg {\n  background-color: rgb(255, 141, 82);\n  width: 100% !important;\n  height: 3%;\n  text-align: center;\n}\n\n.css-13cymwt-control {\n  overflow: auto;\n  max-height: 13%;\n}\n\n.people-picker .flyout .search-box__input {\n  font-family: \"GothamRounded-Book\";\n  font-size: 1rem;\n  padding-left: 2%;\n}\n\n.msgBoxStyle {\n  padding-left: 6.5%;\n  width: 97%;\n}\n\n/*Hide search Number Arrows */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.css-1ahcgob-MuiButtonBase-root-MuiRadio-root.Mui-checked {\n  color: white !important;\n}\n\n@font-face {\n  font-family: GothamRounded-Book;\n  src: url(../font/GothamRounded-Book.otf);\n}\n\n.GothamRounded-Book {\n  font-family: GothamRounded-Book;\n}\n\n@font-face {\n  font-family: GothamRounded-Medium;\n  src: url(../font/GothamRounded-Medium.otf);\n}\n\n.GothamRounded-Medium {\n  font-family: GothamRounded-Medium;\n}\n\n/*----*/\n/* Add this CSS to your styles.css file or create a new CSS file for this component */\n.metadata-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /* min-height: 100vh; */\n  padding: 20px;\n}\n\n.button-container {\n  position: absolute;\n  bottom: auto;\n  left: 0;\n  right: 5;\n  padding: 20px;\n  display: block;\n  justify-content: space-between;\n}\n\n@media (max-width: 768px) {\n  /* Add media query for smaller screens */\n  .button-container {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n.homePageDescription {\n  font-family: \"GothamRounded-Medium\";\n  font-size: 20px;\n  padding-left: 5%;\n}\n.homePageTitle {\n  font-family: \"GothamRounded-Medium\";\n  font-size: 30px;\n  padding: 5%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
